export default {"src":"/_next/static/media/profile-new.4ce45369.svg","height":21,"width":22};